angular.module('rjmNg.directives').directive 'pdwEditDataTargetForm', [
  "notification"
  "errorConstants"
  "app"
  "WarehouseConnections"
  "$url"
  "$routeParams"
  "$location"
  "connectionUtils"
  "$timeout"
  "$clientAppUrl"
  "CONNECTION_CHECKS"
  "appRoute"
  (
    notification
    errorConstants
    app
    WarehouseConnections
    $url
    $routeParams
    $location
    connectionUtils
    $timeout
    $clientAppUrl
    CONNECTION_CHECKS
    appRoute
  ) ->

    restrict: 'E'
    scope: true
    templateUrl: 'directive.pdwEditDataTargetForm.html'
    link: (scope, elem, attrs) ->

      WarehouseConnectionsInstance = WarehouseConnections(app.getClientId())
      scope.supportEmail = app.getSupportEmail()

      scope.connectionsPageUrl = $clientAppUrl('/settings/connection/')

      scope.user = app.getUser()
      scope.showDataTarget = (scope.user.supportAdminId\
        and app.hasFeatureFlag("PDW_SUPPORT_CLIENT"))\
        or app.hasFeatureFlag("PDW_CLIENT")

      if !scope.showDataTarget
        $location.path appRoute("/settings/connection")

      timeoutPromise = null

      scope.baseUrl = $url("")
      scope.savingDataTarget = false
      scope.alphanumericRegex = connectionUtils.REGEX.alphanumeric
      scope.hostRegex = connectionUtils.REGEX.host
      scope.notificationTemplate = 'template.notification.supportLink.html'
      scope.errorMessages = connectionUtils.ERROR_MESSAGES

      scope.clientId = app.getClientId()
      scope.connectionId = null
      scope.dataTarget = null
      scope.notification = ""
      if $routeParams.connectionId? and scope.showDataTarget
        WarehouseConnectionsInstance.get($routeParams.connectionId)
        .then (successResponse) ->
          scope.dataTarget = angular.extend successResponse,
            prettyConnectionType: "Redshift"
          _checkStatus(successResponse)
          scope.dataTarget.properties.port = +scope.dataTarget.properties.port
        , (errorResponse) ->
          notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "dataTarget")
      else
        scope.dataTarget =
          name: ""
          host: ""
          database: ""
          username: ""
          credentials:
            password: ""
          port: 5439

      scope.$on('$destroy', () ->
        _stopStatusChecker()
      )

      scope.saveDataTarget = () ->
        scope.savingDataTarget = true

        if scope.dataTarget.id?
          WarehouseConnectionsInstance.save scope.dataTarget
          .then _onSuccess, _saveError
        else
          WarehouseConnectionsInstance.create scope.dataTarget
          .then _onSuccess, _saveError

      _checkStatus = (connection) ->
        # already have a status
        if connection.check?
          scope.connectionStatus = _lookupStatusMessage(connection.check)
          _handlePendingStatus(connection.check)
          return

        # need to queue a status check
        WarehouseConnectionsInstance.check(connection).then (result) ->
          _stopStatusChecker()
          _startStatusChecker(result.id)
        , ()->
          notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "dataTarget")

      _onSuccess = (successResponse) ->
        scope.savingDataTarget = false
        scope.notification = "The connection was successfully saved and a
        connection test has been queued."
        if !scope.dataTarget.id
          scope.dataTarget.id = successResponse.id
        _checkStatus(successResponse)

      _saveError = (errorResponse) ->
        notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "dataTarget")
        scope.savingDataTarget = false

      _lookupStatusMessage = (check) ->
        switch check.status
          when CONNECTION_CHECKS.STATUS.PENDING then return "Testing..."
          when CONNECTION_CHECKS.STATUS.OK then return "Connection Established Successfully"
          when CONNECTION_CHECKS.STATUS.FAILED
            if check.reason is CONNECTION_CHECKS.FAIL_REASON.NO_CREATE_SCHEMA_RIGHTS
              return CONNECTION_CHECKS.FAIL_REASON_MESSAGES.NO_CREATE_SCHEMA_RIGHTS
            if check.reason is CONNECTION_CHECKS.FAIL_REASON.CANNOT_CONNECT
              return CONNECTION_CHECKS.FAIL_REASON_MESSAGES.CANNOT_CONNECT
            if check.reason is CONNECTION_CHECKS.FAIL_REASON.NOT_REDSHIFT_INSTANCE
              return CONNECTION_CHECKS.FAIL_REASON_MESSAGES.NOT_REDSHIFT_INSTANCE
          else
            return errorConstants.SERVER_ERROR_MESSAGE

      _handlePendingStatus = (check) ->
        if check.status is CONNECTION_CHECKS.STATUS.PENDING
          timeoutPromise = $timeout ->
            _startStatusChecker(check.id)
          , 10000

      _startStatusChecker = (checkId) ->
        WarehouseConnectionsInstance.status(scope.dataTarget.id, checkId).then (result) ->
          scope.connectionStatus = _lookupStatusMessage(result)
          _handlePendingStatus(result)
        , _statusError

      _stopStatusChecker = () ->
        if (angular.isDefined(timeoutPromise))
          $timeout.cancel(timeoutPromise)
          timeoutPromise = null

      _statusError = () ->
        notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "dataTarget")

]
